import axios from 'axios';
// import _ from 'lodash';

// config
const request = axios.create({
  baseURL: process.env.REACT_APP_IMGATE_BACKEND_BASEURL,
});

const headers = (header) => {
  return {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('api_key')}`,
      ...header && header,
    }
  };
};

const querystring = (query) => {
  return {
    params: query
  };
};

// const removeNullInObject = (obj) => {
//   return _.pickBy(obj, function (value, key) {
//     return !_.isEmpty(value);
//   });
// }

export const getForestTripHotelInfo = ({
  encHotelCode: enc_hotel_code,
}) => {
  return request.get('/multifamily/users/forest_trip/hotels',
      querystring({ enc_hotel_code }),
   );
}

export const requestVerificationCode = ({
  hotelId:hotel_id,
  phoneNumber:phone_number,
  expiredAt:expired_at,
  isTestMode:is_test_mode,
}) => {
  return request.post('/multifamily/users/forest_trip/verification_code', {
    hotel_id,
    phone_number,
    expired_at,
    is_test_mode,
  });
}

export const verifyVerificationCode = ({
  hotelId:hotel_id,
  phoneNumber:phone_number,
  verificationCode:verification_code,
}) => {
  return request.post('/multifamily/users/forest_trip/verification_token', {
    hotel_id,
    phone_number,
    verification_code,
  });
}

export const listBooking = () => {
  return request.get('/multifamily/users/forest_trip/bookings', {
    ...headers(),
  });
}

export const issuePincode = ({
  bookingId:booking_id,
}) => {
  return request.post(`/multifamily/users/forest_trip/bookings/${booking_id}/pincodes`,
    {},
    headers(),
  );
}

export const issueMobilekey = ({
  bookingId:booking_id,
}) => {
  return request.post(`/multifamily/users/forest_trip/bookings/${booking_id}/mobilekeys`,
    {},
    headers(),
  );
}